import React, { Component } from 'react';
import moment from 'moment';
import { SERVER_URL } from './ServerConfig'
import InverterCombinerBoxesDetails from './inverter/InverterCombinerBoxesDetails'
import queryString from 'query-string';

export default class CombinerBoxes extends Component {

    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);
        this.state = {
            isLoading: false,
            data: null,
            params : params
        }

        this.mounted = true;

        this.handleBackBtnClick = this.handleBackBtnClick.bind(this);
    }

    componentDidMount() {
        this.fetchInverter();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    fetchInverter() {
        const id = this.state.params.id;
        let token = this.props.user.payload.token;
        let day = moment(new Date()).toISOString();
        fetch(SERVER_URL + '/v1/inverters/' + id + '/getCombinerBoxesCurrent', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token
            },
            body: JSON.stringify({
                day: day
            })
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (!this.mounted) {
                    return;
                }
                this.interval = setInterval(() => this.doFetchInterval(), 5000);
                this.setState({ isLoading: false, data: data.content });
            })
    }

    doFetchInterval() {
        clearInterval(this.interval);
        this.fetchInverter();
    }

    getStatus(item, mStatus) {
        if (!mStatus || !item.mTime) {
            return false;
        }
        const now = moment();
        const statusTime = moment(item.mTime).add(4, 'hours');

        const duration = now.diff(statusTime, 'minutes');
        if (duration > 15) {
            return false;
        }
        return true;
    }

    drawStatus(status) {
        if (status) {
            return (
                <span className="badge bg-success">ON</span>
            );
        }
        return (<span className="badge bg-danger">OFF</span>);
    }

    formatNumberWithStatus(number, status) {
        if (!status) {
            return 0;
        }
        return this.formatNumber(number);
    }

    formatNumber(number) {
        if (!number) {
            return 0;
        }
        return Number(number).toFixed(3);
    }

    getStringNumber(stringName) {
        let combinerboxes = this.state.data.combinerboxes;
        if (!combinerboxes || combinerboxes.length == 0) {
            return "0";
        }
        let value = combinerboxes[0][stringName] / 1000;
        return this.formatNumber(value);
    }

    handleBackBtnClick(event) {
        this.props.history.goBack();
    }


    render() {
        const data = this.state.data;
        const user = this.props.user;
        if (!data) {
            return (
                <h1>Loading...</h1>
            )
        }
        let inverter = data.inverter;

        return (            
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6 d-flex">
                                <button type="button" className="btn btn-default none-border mr-2" onClick={this.handleBackBtnClick} data-toggle="tooltip" data-placement="right" title="Back to previous page">
                                    <i className="fa fa-arrow-left fa-2"></i>
                                </button>
                                <h4>Inverter {inverter.mName}</h4>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="">
                    <div className="row">                        
                        <div className="col-12">
                            <InverterCombinerBoxesDetails history={this.props.history} user={user} inverter={inverter} />
                        </div>
                        <div className="card col-12 mt-4">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-12 col-md-4">
                                        <ul className="list-group list-group-unbordered m-3">
                                            <li className="list-group-item">
                                                <b>String 1</b> <div className="ml-4 float-right">{this.getStringNumber('mC1Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 2</b> <div className="ml-4 float-right">{this.getStringNumber('mC2Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 3 </b> <div className="ml-4 float-right">{this.getStringNumber('mC3Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 4</b> <div className="ml-4 float-right">{this.getStringNumber('mC4Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 5</b> <div className="ml-4 float-right">{this.getStringNumber('mC5Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 6</b> <div className="ml-4 float-right">{this.getStringNumber('mC6Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 7</b> <div className="ml-4 float-right">{this.getStringNumber('mC7Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 8</b> <div className="ml-4 float-right">{this.getStringNumber('mC8Cur')} (A)</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <ul className="list-group list-group-unbordered m-3">
                                            <li className="list-group-item">
                                                <b>String 9</b> <div className="ml-4 float-right">{this.getStringNumber('mC9Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 10</b> <div className="ml-4 float-right">{this.getStringNumber('mC10Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 11</b> <div className="ml-4 float-right">{this.getStringNumber('mC11Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 12</b> <div className="ml-4 float-right">{this.getStringNumber('mC12Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 13</b> <div className="ml-4 float-right">{this.getStringNumber('mC13Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 14</b> <div className="ml-4 float-right">{this.getStringNumber('mC14Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 15</b> <div className="ml-4 float-right">{this.getStringNumber('mC15Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 16</b> <div className="ml-4 float-right">{this.getStringNumber('mC16Cur')} (A)</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <ul className="list-group list-group-unbordered m-3">
                                            <li className="list-group-item">
                                                <b>String 17</b> <div className="ml-4 float-right">{this.getStringNumber('mC17Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 18</b> <div className="ml-4 float-right">{this.getStringNumber('mC18Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 19</b> <div className="ml-4 float-right">{this.getStringNumber('mC19Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 20</b> <div className="ml-4 float-right">{this.getStringNumber('mC20Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 21</b> <div className="ml-4 float-right">{this.getStringNumber('mC21Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 22</b> <div className="ml-4 float-right">{this.getStringNumber('mC22Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 23</b> <div className="ml-4 float-right">{this.getStringNumber('mC23Cur')} (A)</div>
                                            </li>
                                            <li className="list-group-item">
                                                <b>String 24</b> <div className="ml-4 float-right">{this.getStringNumber('mC24Cur')} (A)</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}